<div class="max-w-full mx-auto">
  <h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">
    Proveedores fallidos en el proceso de facturación
  </h2>
  <div class="overflow-auto rounded-lg shadow-lg">
    <table class="w-full leading-normal">
      <thead class="bg-orange-500 text-white">
        <tr>
          <th class="px-5 py-3 border-b-2 border-orange-600">ID PROVEEDOR FAMILIA</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Nombre del Proveedor</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Fecha de Inicio de Facturación</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Fecha de Fin de Facturación</th>
          <th class="px-5 py-3 border-b-2 border-orange-600">Acciones</th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr *ngFor="let provider of failedProviders; even as isEven"
          class="hover:bg-orange-200 transition duration-150 ease-in-out">
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ provider.providerId }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ provider.providerName }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ provider.billingStartDate }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ provider.billingEndDate }}</td>
          <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">
            <button class="bg-orange-500 text-white px-4 py-2 rounded"
              (click)="sendFailedProviderBillingData(provider)">Enviar</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="failedProviders.length === 0 && !isLoading" class="bg-white shadow-md rounded-lg mt-5 p-7">
    <h1 class="text-2xl font-bold text-center text-gray-600">No se encontraron proveedores fallidos.</h1>
  </div>

  <ng-container *ngIf="failedProviders.length > 0">
    <div class="relative mb-5">
      <mat-paginator [length]="totalItems" [pageSize]="itemsPerPage" [pageSizeOptions]="[10, 20, 50]"
        (page)="handlePageEvent($event)"></mat-paginator>
    </div>
  </ng-container>

  <div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
    <svg class="animate-spin h-5 w-5 text-orange-500 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none"
      viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
      </path>
    </svg>
  </div>
</div>